import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  MealType,
  MealTypeValues,
  Source,
  SourceValues,
  ValuesCateringMeal,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionCateringMealDto } from './dto.type';

export class QuestionCateringMealMapper {
  static dtoToEntity(
    dto: QuestionCateringMealDto,
  ): ImpactCo2Answer<ValuesCateringMeal> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'CATERING_MEAL',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        mealType: validateValueInType<MealType>(dto.mealType, MealTypeValues),
        mealCount: dto.mealCount,
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesCateringMeal>,
    projectId: number,
  ): Omit<QuestionCateringMealDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      mealType: answer.values.mealType,
      mealCount: answer.values.mealCount,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
